import Vue from 'vue'
import Vuex from 'vuex'
import { API } from '@/lib/API'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: true,
    api: new API(),
    consonantList: [] as any[],
    vowelList: [] as any[],
    toneList: [] as any[],
    numberOfSyllablesList: [
      { value: -1, text: '指定しない' },
      { value: 1, text: '1 音節' },
      { value: 2, text: '2 音節' },
      { value: 3, text: '3 音節' },
      { value: null, text: '4 音節以上' },
    ],
    languageList: [
      { value: 'zh', text: '中国語' },
      { value: 'ja', text: '日本語' },
    ],
    searchResult: null as (any[] | null),
    pagination: {} as any,
    isEditable: process.env.VUE_APP_IS_EDITABLE == "true",
    linkPageUrl: process.env.VUE_APP_LINK_PAGE_URL,
  },
  getters: {
  },
  mutations: {
    setConsonantList(state, consonantList: any[]) {
      consonantList = [ { group: '---' }, ...consonantList ];
      state.consonantList = consonantList;
    },
    setVowelList(state, vowelList: any[]) {
      state.vowelList = vowelList;
    },
    setToneList(state, toneList: any[]) {
      state.toneList = toneList;
    },
    setSearchResult(state, searchResult: any[]) {
      state.searchResult = searchResult;
    },
    clearSearchResult(state) {
      state.searchResult = null;
      state.pagination = {};
    },
    setLoading(state, val: boolean) {
      state.loading = val;
    },
  },
  actions: {
    async initOptions({ commit, state }) {
      commit('setConsonantList', await state.api.getConsonants());
      commit('setVowelList', await state.api.getVowels());
      commit('setToneList', await state.api.getTones());
    },
    async searchWords({ commit, state }, params) {
      const response = await state.api.searchWords(params);
      const pagination = {
        pageCount: response.headers['x-paging-pagecount'],
        pageNo: response.headers['x-paging-pageno'],
        pageSize: response.headers['x-paging-pagesize'],
        total: response.headers['x-paging-totalrecordcount'],
      };
      state.pagination = pagination;
      commit('setSearchResult', response.data);
    },
  },
})

